import { createSlice } from "@reduxjs/toolkit";

export const utilitySlice = createSlice({
  name: "utility",
  initialState: {
    isLoggedIn: false,
    selectedCity: '',
    businessOnboardingComplete: false,
  },
  reducers: {
  setIsLoggedIn: (state, action) => {
    state.isLoggedIn = action.payload;
  },
  setIsLoggedOut: (state) => {
    state.isLoggedIn = false;
    state.businessOnboardingComplete = false;
    state.userData = null;
  },
  onsaveuserData: (state, action) => {

    state.userData = {
      ...action.payload.userData?.user,
      ...action.payload.userData,
    }
  },
  onsaveSelectedCity: (state, action) => {
    state.selectedCity = action.payload.selectedCity;
  },
  setBusinessOnboardingComplete: (state, action) => {
    state.businessOnboardingComplete = action.payload;
  },
  updateUserProfile: (state, action) => {
    if (!state.userData) return;
    const { name, city } = action.payload || {};
    if (name !== undefined) state.userData.name = name;
    if (city !== undefined) state.userData.city = city;
  },
},
});
export const { setIsLoggedIn, setIsLoggedOut, onsaveuserData, onsaveSelectedCity, setBusinessOnboardingComplete, updateUserProfile } = utilitySlice.actions;
export default utilitySlice.reducer;